export default "__VITE_ASSET__CLe38Umi__"